import { Helmet } from "react-helmet";
import React from "react";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TotalSalesBatch from "components/dashboard/TotalSalesBatch";
import BudgetRates from "components/dashboard/BudgetRates";
import SalesByProvince from "components/dashboard//SalesByProvince";
import SalesByDistricts from "components/dashboard//SalesByDistricts";
import PeriodicDailySales from "components/dashboard/PeriodicSalesByDay";

import IdleTimeout from "components/IdleTimeout/IdleTimeout";
import DateMenu from "components/Card/CardHeader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { usePromiseTracker } from "react-promise-tracker";
import { dailyDurationSales } from "components/dashboard/TotalSales";

const PresetSales = () => {
  const [dayShow, setdayShow] = React.useState(true);
  const [weekShow, setWeekShow] = React.useState(false);
  const [monthShow, setMonthShow] = React.useState(false);
  const [threeMonthsShow, setThreeMonthsShow] = React.useState(false);
  const [sixMonthsShow, setSixMonthsShow] = React.useState(false);

  const rate = useSelector((state: RootState) => state.budgetRates);
  const { promiseInProgress } = usePromiseTracker();

  const [dailyTotalSales, setDailyTotalSales] = React.useState({});

  const durationGet = (
    dayShow: boolean,
    weekShow: boolean,
    monthShow: boolean,
    threeMonthsShow: boolean,
    sixMonthsShow: boolean,
  ) => {
    setdayShow(dayShow);
    setWeekShow(weekShow);
    setMonthShow(monthShow);
    setThreeMonthsShow(threeMonthsShow);
    setSixMonthsShow(sixMonthsShow);
  };

  const GetTotalSales = (TotalSales: dailyDurationSales): any => {
    setDailyTotalSales(TotalSales);
  };
  const navigate = useNavigate();
  const redirect = () => {
    navigate("/app/dashboard");
  };

  const notLoaded = promiseInProgress || rate.isLoading;

  return (
    <>
      <Helmet>
        <title>Sales Report | Nutriart Stores</title>
      </Helmet>
      <IdleTimeout />
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    Sales Report
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Preset sales overview across all stores
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<CalendarMonthIcon />}
                  onClick={redirect}
                >
                  Custom Duration
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={4} xl={3}>
                  <DateMenu durationGet={durationGet} showDates={true} />
                </Grid>

                <Grid item xs={12} lg={8} xl={9}>
                  <Grid container spacing={3}>
                    <TotalSalesBatch
                      dayShow={dayShow}
                      weekShow={weekShow}
                      monthShow={monthShow}
                      threeMonthsShow={threeMonthsShow}
                      sixMonthsShow={sixMonthsShow}
                      GetTotalSales={GetTotalSales}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {!dayShow && (
              <Grid item xs={12}>
                <PeriodicDailySales
                  avgItemTr="1"
                  dayShow={dayShow}
                  weekShow={weekShow}
                  monthShow={monthShow}
                  threeMonthsShow={threeMonthsShow}
                  totalSales={dailyTotalSales}
                />
              </Grid>
            )}

            <Grid item lg={6} md={6} xl={6} xs={12}>
              <SalesByProvince
                dayShow={dayShow}
                weekShow={weekShow}
                monthShow={monthShow}
                threeMonthsShow={threeMonthsShow}
                sixMonthsShow={sixMonthsShow}
              />
            </Grid>

            <Grid item lg={6} md={6} xl={6} xs={12}>
              <SalesByDistricts
                dayShow={dayShow}
                weekShow={weekShow}
                monthShow={monthShow}
                threeMonthsShow={threeMonthsShow}
                sixMonthsShow={sixMonthsShow}
              />
            </Grid>

            <Grid item lg={12} md={12} xl={12} xs={12}>
              <BudgetRates
                dayShow={dayShow}
                weekShow={weekShow}
                monthShow={monthShow}
                threeMonthsShow={threeMonthsShow}
                sixMonthsShow={sixMonthsShow}
              />
            </Grid>
          </Grid>
        </Container>

        <Backdrop
          open={notLoaded}
          sx={{
            zIndex: (theme) => theme.zIndex.modal + 1,
            backgroundColor: "rgba(15, 23, 42, 0.6)",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress size={56} thickness={4} sx={{ color: "#ffffff" }} />
            <Typography color="common.white" sx={{ mt: 2 }}>
              Loading sales data…
            </Typography>
          </Box>
        </Backdrop>
      </Box>
    </>
  );
};

export default PresetSales;
